import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../../../Components/ui/carousel'
import { useNavigate } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import actionCarouselData from './ActionCarouselData'
import basketRowIcon from '../../../assets/SVGS/fabits-basket-row-icon.svg'

const ActionCarousel = ({ plans, mfData, receivedData }) => {
  const navigate = useNavigate()

  return (
    <Carousel
      autoHeight={false}
      opts={{
        align: 'start',
        slideStep: 4,
      }}
    >
      <CarouselContent className='-ml-2 md:-ml-3'>
        {actionCarouselData.map((el, index) => (
          <CarouselItem
            key={el.id || index}
            className='basis-1/2 pl-2 md:basis-1/4 md:pl-3 lg:basis-1/5 2xl:basis-1/6'
          >
            <div
              role='button'
              tabIndex={0}
              className='group h-full cursor-pointer rounded-2xl border border-[var(--fb-border)] bg-[var(--fb-surface-muted)] p-4 transition-all duration-200 hover:border-[var(--fb-accent)] hover:bg-[var(--fb-surface)] hover:shadow-[var(--fb-shadow-sm)]'
              onClick={() =>
                navigate(el.link, {
                  state: { plans, mfData, receivedData },
                })
              }
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault()
                  navigate(el.link, {
                    state: { plans, mfData, receivedData },
                  })
                }
              }}
            >
              <div className='flex h-full min-h-[132px] flex-col gap-4'>
                <div className='flex items-start justify-between'>
                  <img
                    src={basketRowIcon}
                    className='fabits-basket-row-icon size-11 rounded-xl'
                    alt=''
                    aria-hidden='true'
                  />
                  <ChevronRight className='size-5 text-[var(--fb-text-disabled)] transition-colors group-hover:text-[var(--fb-accent-text)]' />
                </div>
                <div>
                  <p className='font-DMSans text-sm font-bold tracking-tight text-[var(--fb-text-strong)] md:text-base'>
                    {el.title}
                  </p>
                  <p className='mt-1 text-xs leading-relaxed text-[var(--fb-text-muted)] md:text-sm'>
                    {el.text}
                  </p>
                </div>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  )
}

export default ActionCarousel
